module.exports = __webpack_public_path__ + "static/img/ryzs1ab.1a824dba.png";